import { render } from "./addTransaction.vue?vue&type=template&id=2a2a9278&scoped=true"
import script from "./addTransaction.vue?vue&type=script&lang=js"
export * from "./addTransaction.vue?vue&type=script&lang=js"

import "./addTransaction.vue?vue&type=style&index=0&id=2a2a9278&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2a9278"]])

export default __exports__